"use strict";

exports.__esModule = true;
exports.GroupType = exports.CssDataTypeEnum = void 0;
let CssDataTypeEnum = exports.CssDataTypeEnum = /*#__PURE__*/function (CssDataTypeEnum) {
  CssDataTypeEnum["UNKNOWN_CssDataType"] = "UNKNOWN_CssDataType";
  CssDataTypeEnum["number"] = "number";
  CssDataTypeEnum["string"] = "string";
  CssDataTypeEnum["angle"] = "angle";
  CssDataTypeEnum["color"] = "color";
  CssDataTypeEnum["length"] = "length";
  CssDataTypeEnum["percentage"] = "percentage";
  CssDataTypeEnum["lengthPercentage"] = "lengthPercentage";
  CssDataTypeEnum["blendMode"] = "blendMode";
  CssDataTypeEnum["customEnum"] = "customEnum";
  CssDataTypeEnum["time"] = "time";
  return CssDataTypeEnum;
}({});
let GroupType = exports.GroupType = /*#__PURE__*/function (GroupType) {
  GroupType["preset"] = "preset";
  return GroupType;
}({});
//# sourceMappingURL=types.js.map